<template>
  <div id="QuestionContainer" class="z-index-md mobile-width">

    <!-- METRICS -->
    <div id="metricContainer" ref="metricContainer" class="d-flex flex-column p-2 frosted-glass">
      <div class="metric-box d-flex justify-content-around">

          <div class="metric-parent text-center p-2" v-for="(metric,index) in metricObject" :key="'metric-'+index" :class="{'active': metric.model === true}">
            <div class="metric-value mb-2">
              {{metric.prettyValue}}
            </div>
            <div class="metric-label">
              {{metric.label}}
            </div>
          </div>
      </div>
    </div>

    <div class="border-break"></div>

    <!-- OPTMIZE  -->
    <div id="optimizeContainer" ref="optimizeContainer" class="d-flex flex-column p-2 mb-2">

      <div class="header p-2 mt-2 mb-2">
        Select an option to optimize for housing, energy independence, or public space. Make your own mix by customizing below; select ‘my mix’ to see your results. 
      </div>

      <div class="optimize-options d-flex justify-content-around text-center">
        <div class="optimize-button-option p-2" 
        v-for="(option, i) in optimizeOptions" :key="i" 
        :class="{'active': option.active === true ,'disabled': loadingFlag === true}"
        @click="optimize(option.dataModel)"
        >
          {{option.label}}
        </div>
        <div class="optimize-button-option p-2 ml-3" :class="{'active': myMix === true,'disabled': loadingFlag === true}"  @click="callQuestionUpdate">
          my mix
        </div>
      </div>
    </div>
    <!-- <div class="border-break mt-3"></div> -->

    <!-- QUESTIONS -->
    <QuestionReview 
    :questions="reviewQuestions" 
    @callInputUpdate="setInputValues"
    @clearOptimize="clearOptimize"
    />
  </div>
</template>

<script>

import QuestionReview from "@/components/QuestionReview.vue";

import {
  questionsTemplate
} from '@/assets/library/questions.js';

import { mapGetters } from 'vuex';

export default {
  name: "QuestionContainer",
  components:{
    QuestionReview
  },
  data(){
    return {
      questions: [],
      optimizeOptions: [
        {
          label: "housing",
          dataModel: "out_percentage_housed",
          active: false,
          button: true
          
        },
        {
          label: "energy",
          dataModel: "out_energy_independence",
          active: false,
          button: true
        },
        {
          label: "public space",
          dataModel: "out_green_access",
          active: false,
          button: true
        }
      ],
      myMix: false
    }
  },
  computed:{
    ...mapGetters({
      modelData: "getModelData",
      metricObject: "getMetricObject",
      loadingFlag: "getLoadingFlag"
    }),
    reviewQuestions(){
      return this.questions;
    },
    activeMetric(){
      return Object.values(this.metricObject).filter((e) => e.model === true)[0]
    }
  },
  mounted(){
    this.getMetricRatings();
  },
  watch:{
    metricObject(){
      this.getMetricRatings();
    }
  },
  created () {
    this.questions = questionsTemplate.map((q) => {
      if(q.type === 'input'){
        q.options = q.values.map((d,i) => {
          return {'text': d, "value": i}
        })
        q.combinations = this.getCombinations(q.values)
      }
      return q;
    });
  },
  methods:{
    callQuestionUpdate(){
      this.clearOptimize(null);
      this.myMix = true;
      this.$store.commit('resetMetrics', true);
      
      this.setInputValues();
    },
    clearOptimize(category){
      this.optimizeOptions.forEach((e)=>{
        if(e.dataModel !== category){
          e.active = false;
        }else{
          e.active = true;
        }
      });
    },
    optimize(category){

      if(this.loadingFlag=== false){

        this.clearOptimize(category);
        this.myMix = false

        this.modelData.sort((a, b) => ( parseFloat(a[category]) < parseFloat(b[category])) ? 1 : -1);
        const topTen = this.modelData.slice(0, 10);
        const index = Math.floor((Math.random() * 10))
        const chosenOne = topTen[index];
        const keys = Object.keys(chosenOne).filter((e)=> e.split("_")[0] === 'in');

        this.questions.forEach((d)=>{
          keys.forEach((key)=>{

            if(d.key === key){
              if(d.type === 'input'){
                const k = parseInt(chosenOne[key])
                d.answer = d.combinations[k]
              }else if(d.type === 'radio'){
                d.answer = chosenOne[key];
              }
            }
          });
        });
        this.setInputValues();
      }
    },
    getMetricRatings(){
      for(const key in this.metricObject){
        let obj = this.metricObject[key];

        if(obj.scaleQuantile !== undefined){
  
          let value = obj.scaleQuantile(obj.value);
  
          obj.prettyValue = value + "%";
        }
      }
    },
    getCategoryIndex(question){

      let modelValue = null

      question.combinations.forEach((arr,i)=>{
        if(this.areArraysEqualSets(arr, question.answer)){
          modelValue = i
        }
      });

      return modelValue;
    },
    areArraysEqualSets(a1, a2) {
      let superSet = {};

      for (let i = 0; i < a1.length; i++) {
        const e = a1[i] + typeof a1[i];
        superSet[e] = 1;
      }

      for (let i = 0; i < a2.length; i++) {
        const e = a2[i] + typeof a2[i];
        if (!superSet[e]) {
          return false;
        }
        superSet[e] = 2;
      }

      for (let e in superSet) {
        if (superSet[e] === 1) {
          return false;
        }
      }

      return true;
    },
    getUniqueSortedCombinations(inputArray){
  
      const getAllSubsets = theArray => theArray.reduce((subsets, value) => subsets.concat(subsets.map(set => [...set,value])),[[]]);
      
      let subset = getAllSubsets(inputArray)
      
      subset.sort((a, b) => a.length - b.length || String(a).localeCompare(String(b)))
      
      subset.shift()
      
      return subset
    },
    getCombinations (inputValues) {
      return this.getUniqueSortedCombinations(Object.keys(inputValues)).map((arr)=>{
        return arr.map(Number);
      });
    },
    getModelIteration ( compareObject ){

      let keys = Object.keys(compareObject);
      let match = keys.length

      return this.modelData.filter((d)=>{

        let matchCount = 0;

        keys.forEach((key)=>{
          if(d[key] === compareObject[key]){
            matchCount +=1;
          }
        });
        return matchCount === match ? true : false;
      })[0]
    },
    setInputValues () {

      this.$store.commit('setLoadingFlag', true);

      let compareObject = {}

      this.questions.forEach((q) =>{

        if(q.type === 'input'){
          q.modelValue = this.getCategoryIndex(q);
        }
        
        else if (q.type === 'radio'){
          q.modelValue = q.answer
        }

        compareObject[q['key']] = q['modelValue'].toString();

      });

      const selectedModel = this.getModelIteration(compareObject);

      this.$store.commit('setMetricObject', selectedModel);
      this.$store.commit('setModelID', selectedModel['iteration']);
    }
  }
}
</script>

<style lang="scss">

#QuestionContainer{
  position: relative;
  top: $container-offset;
  margin: none;
  max-width: $max-container-width;

  .border-break{
    border-bottom: 1px solid $off-white;
  }
  .loading-parent{
    border: 1px solid $off-white;
  }

  .header{
    @include fontStyling($font-md, $font-med, $off-white, none);
  }
  .description-text{
    @include fontStyling($font-description, $font-reg, $off-white, none);
  }
  .highlight-text{
    color: $orange
  }
  .button-container{
    padding:1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;

    background: $off-white;
    color: $blue;

    font-size: $button-size;
    font-weight: $font-bold;
    text-transform: uppercase;
    cursor: pointer;

    &:hover{
      color: $orange;
      // background: transparent;
    }
  }
  
  #optimizeContainer{
    background: $blue;

    .optimize-button-option{
      width: calc(100% / 4);

      @include fontStyling($font-md, $font-med, $off-white, none);

      border: 1px solid $off-white;
      
      transition: background color .1s ease;

      &.disabled{
        pointer-events: none!important;
        user-select: none;
        color: $grey;
      }
      &:hover, &.active{
        cursor: pointer;
        background: $off-white;
        color: $orange;
      }
    }
  }
  #metricContainer{

    .metric-description{
      @include fontStyling($font-sm, $font-reg, $black, none);
    }

    .metric-value{
      @include fontStyling($font-lg, $font-bold, $orange, uppercase);
    }

    .metric-label{
      line-height: calc(#{$font-sm} + 0.1rem);
      @include fontStyling($font-sm, $font-bold, $black, none);
    }

    .metric-parent{
      position: relative;
      width: calc(100% / 5);

      // &.active > :before{
      //   content: "";
      //   position: absolute;
      //   border-top: $question-border;
      //   top: 0;
      //   right: 0;
      //   left: calc(#{$border-short} + 20%);
        
      //   border-right: $question-border;
      //   height: $border-short;
      // }

      // &.active > :after{
      //   content: "";
      //   position: absolute;
      //   border-left: $question-border;
      //   left: 0;
      //   top: 60%;
      //   bottom: 0;
        
      //   border-bottom: $question-border;
      //   width: $border-long;
      // }
    }
  }
}
</style>